import React from 'react';

const DataSet = ({ props, label, children }) => (
    <div className="form-group">
        <label className="sidebar-label">{label}</label>
        <div className="sidebar-text">{children}</div>
    </div>
);

export default DataSet;